import { useHtmlId } from '@ipfabric/frontend-shared-assets/utils/react/HtmlId';
import type { FC } from 'react';
import { FormField } from '../FormField/FormField';
import type { FormFieldBaseProps } from '../FormField/FormField.types';
import { IPSubnetInput } from '../IPSubnetInput/IPSubnetInput';
import type { IPSubnetInputProps } from '../IPSubnetInput/IPSubnetInput.types';

type IPSubnetFieldType = IPSubnetInputProps & FormFieldBaseProps;

export const IPSubnetField: FC<IPSubnetFieldType> = ({
  className,
  ...props
}) => {
  const { name, error, ...restProps } = props;
  const ipSubnetInputId = useHtmlId('IpSubnetInput');
  return (
    <FormField {...restProps} htmlFor={ipSubnetInputId} className={className}>
      <IPSubnetInput
        {...restProps}
        error={error}
        name={name}
        inputId={ipSubnetInputId}
      />
    </FormField>
  );
};
